<template>
  <div class="info-block container"
    :class="[containerClass, (noGapTop ? '' : 'is-gap-top')]"
    data-aos="fade-in" data-aos-once="true"><!-- is-fluid -->

    <div class="columns is-gapless is-multiline"
      v-if="!noHeader"
      :class="[columnsClass]"
      :style="[(noGapBottom ? { paddingBottom: 0, marginBotom: 0 } : {})]">

      <div class="column vcentered"
        :class="[
          ((isImage || isFile || isVideoLink || isVideoYoutube) && !isTopFull ? 'is-6' : 'is-12'),
          (containerIsCentered ? 'has-text-centered' : 'has-text-left'),
        ]"
        :style="[
          { backgroundColor: columnsClassColor },
          { color: columnsTextColor },
        ]">

        <div class="is-gap is-pad-large"
          :style="[(noGapBottom ? { paddingBottom: 0, marginBotom: 0 } : {}), contentStyle]">

          <h1 v-if="data && data.title">
            {{ data.title }}
          </h1>

          <hr v-if="data && data.title"
            :class="[(containerIsCentered ? 'div-centered' : '')]" />

          <h3 v-if="data && data.subtitle">
            {{ data.subtitle }}
          </h3>

          <p v-if="data && data.description"
            v-html="descriptionContent"
            class="is-gap-large-top showdown">
          </p>

          <slot name="default" v-if="isTopHeader">
          </slot>

          <el-button v-if="data && data.link && data.link2"
            class="button color-white-bg is-gap-large-top"
            @click="onLink(data && data.link)">
            {{ data.link2 }}
          </el-button>

        </div>
      </div>

      <div class="column" :class="(isTopFull ? 'is-12' : 'is-6')" v-if="isImage">
        <div v-if="isDesktop && !isFullImage"
          class="image-bg-wrapper"
          :class="columnClass"
          style="width:100%;height:100%;"
          :style="[
            { backgroundImage: `url('${data.image && data.image.path}')` },
            imageStyle,
            { backgroundColor: columnsClassColor },
            { color: columnsTextColor },
          ]"
          role="img"
          :alt="data.image && data.image.description"
          :title="data.image && data.image.description"
          :aria-label="data.image && data.image.description">
          <!-- // class vcentered-img-wrapper -->
          <!-- <img :src="data.image.path"
            style="width:100%;"
            role="img"
            :alt="data.image && data.image.description"
            :aria-label="data.image && data.image.description"
          /> -->
          &nbsp;
        </div>
        <div v-else-if="isDesktop && isFullImage"
          class="image-bg-wrapper is-full"
          role="img"
          :alt="data.image && data.image.description"
          :title="data.image && data.image.description"
          :aria-label="data.image && data.image.description"
          :style="[imageStyle]">
          <img :src="data.image.path"
            style="width:100%;"
            role="img"
            :alt="data.image && data.image.description"
            :aria-label="data.image && data.image.description"
          />
        </div>
        <div v-else
          class=""
          :style="[imageStyle, side]">
          <img :src="(data.image_mobile && data.image_mobile.path) || (data.image && data.image.path)"
            role="img"
            :alt="(data.image_mobile && data.image_mobile.description) || (data.image && data.image.description)"
            :aria-label="(data.image_mobile && data.image_mobile.description) || (data.image && data.image.description)"
            style="width:100%;"
          />
        </div>
      </div>

      <div class="column is-6" v-else-if="isFile">
        <div :class="(isDesktop ? 'vcentered-img-wrapper' : '')"
          style="width:100%;"
          :style="[videoWrapperStyle]">
          <video width="320" height="240" controls style="width:100%;">
            <source :src="data.file.path" type="video/mp4" />
            <!-- <source src="movie.ogg" type="video/ogg" /> -->
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <div class="column is-6" v-else-if="isVideoLink">
        <div :class="(isDesktop ? 'vcentered-img-wrapper' : '')"
          style="width:100%;"
          :style="[videoWrapperStyle]">
          <video width="320" height="240" controls style="width:100%;">
            <source :src="data.link3" type="video/mp4" />
            <!-- <source src="movie.ogg" type="video/ogg" /> -->
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <div class="column is-6" v-else-if="isVideoYoutube && isVideoYoutubeVideoId">
        <div :class="(isDesktop ? 'vcentered-img-wrapper' : '')"
          style="width:100%;"
          :style="[videoWrapperStyle]">
          <div id="youtube" style="width:100%;">
            <youtube
              :video-id="youtubeExtractVideoId(data.link3)"
              player-width="100%"
              :player-vars="{}"
              style="display:block;">
              <!-- autoplay: 1 -->
            </youtube>
          </div>
        </div>
      </div>

      <div class="column is-6" v-else-if="isVideoYoutube">
        <div class="vcentered-img-wrapper">
          <span>(Invalid YouTube link: {{ data.link3 }})</span>
        </div>
      </div>

    </div>

    <slot name="out-container" v-if="isTopHeader"></slot>

  </div>
</template>

<script>
import Constants from '@/constants'
import EventBus from '@/controllers/EventBus'
import Util from '@/util'
// import Site from '@/apis/site'

export default {
  name: 'info-block',
  props: {
    containerClass: Array,
    data: Object,
    // contentStyle: Object,
    isCentered: Boolean,
    noHeader: Boolean,
    noGapBottom: Boolean,
    noGapTop: Boolean,
  },
  components: {
  },
  data () {
    return {
      isDesktop: true,
    }
  },
  computed: {
    meta () {
      return this.data && this.data.meta
    },

    containerIsCentered () {
      let meta = this.meta
      return (meta && meta.container && meta.container.isCentered) || this.isCentered
    },

    columnsClass () {
      let meta = this.meta
      return (meta && meta.container && meta.container.class) || ''
    },

    columnsClassColor () {
      let columnsClass = this.columnsClass
      if (!columnsClass || columnsClass.length <= 0) return '#ffffff'
      switch (columnsClass) {
        case 'color-green-bg':
          return Constants.Color.GREEN
        case 'color-gray-bg':
          return '#000000'
        case 'color-lightgreen-bg':
          return Constants.Color.LIGHTGREEN
        case 'color-beige-bg':
          return Constants.Color.BEIGE
        case 'color-white-bg':
        default:
          break
      }
      return '#ffffff'
    },

    columnsTextColor () {
      let columnsClass = this.columnsClass
      if (!columnsClass || columnsClass.length <= 0) return '#000000'
      switch (columnsClass) {
        case 'color-green-bg':
        case 'color-gray-bg':
          return '#ffffff'
        case 'color-lightgreen-bg':
        case 'color-beige-bg':
        case 'color-white-bg':
        default:
          break
      }
      return '#000000'
    },

    contentStyle () {
      let meta = this.meta
      return (meta && meta.content && meta.content.style) || {}
    },

    videoWrapperStyle () {
      let meta = this.meta
      return (meta && meta.video && meta.video.wrapper && meta.video.wrapper.style) || {}
    },

    descriptionContent () {
      let data = this.data
      return Util.string.showdown(data && data.description)
    },

    imageStyle () {
      let meta = this.meta
      return (meta && meta.image && meta.image.style) || {}
    },

    isImage () {
      let data = this.data
      return data && data.image && data.image.path && data.image.path.length > 0
    },

    isFile () {
      let data = this.data
      return data && data.file && data.file.path && data.file.path.length > 0
    },

    isVideoLink () {
      let data = this.data
      return data && data.link3 && data.link3.length > 0 &&
        data.link3.toLowerCase().includes('.mp4') &&
        !data.link3.toLowerCase().includes('youtube')
    },

    isVideoYoutube () {
      let data = this.data
      return data && data.link3 && data.link3.length > 0 &&
        data.link3.toLowerCase().includes('youtube')
    },

    isVideoYoutubeVideoId () {
      let data = this.data
      return data && data.link3 && data.link3.length > 0 &&
        this.youtubeExtractVideoId(data.link3)
    },

    isFullImage () {
      return (this.meta && this.meta.imageType) === 'full-image'
    },

    isTopFull () {
      return (this.meta && this.meta.arrangement) === 'top-header-bottom-image'
    },

    isTopHeader () {
      let arrangement = this.meta && this.meta.arrangement
      return arrangement === 'top-header'
    },
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    await this.refresh()
  },
  methods: {
    async refresh () {
    },

    onLink (link) {
      this.$router.push({ path: link })
    },

    youtubeExtractVideoId (url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
      var match = url.match(regExp)
      return (match && match[7].length === 11) ? match[7] : false
    }
  },
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style lang="scss">
#youtube-player-1 {
  display: block !important;
}
</style>

<style scoped lang="scss">
@import "../../styles/app_setting.scss";

// .info-block {
// }

</style>
